import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import useApi from "../../hooks/useApi";
import { Navigate, useNavigate } from "react-router-dom";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import { images } from "../../assets/images";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import { validateEmail } from "../../../srcWeb/utils/validations/profile";
import apiClient from "../../utils/api/apiClient";

const ForgetPassword = () => {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    userName: "",
  });

  const [FORGET_PASSWORD_FIELDS, SET_FORGET_PASSWORD_FIELDS] = useState([
    {
      title: "Enter your username",
      value: "userName",
      isPassShow: true,
      icons: icons.userIcon,
    },
    {
      title: "Enter your email",
      value: "email",
      isPassShow: true,
      icons: icons.emailIcon,
    },
  ]);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (
      formData?.userName?.trim() === "" ||
      formData?.userName?.trim() === null
    ) {
      toast.error("Please enter username");
    } else if (
      formData?.email?.trim() === "" ||
      formData?.email?.trim() === null
    ) {
      toast.error("Please enter your email");
    } else if (!validateEmail(formData?.email?.trim())) {
      toast.error("Please enter valid email");
    } else {
      const userDetail = {
        emailId: formData.email.trim(),
        username: formData.userName.trim(),
      };

      let dataToSend = userDetail;
      await apiClient({
        url: `${apiUrls.user.forgetPassword}`,
        data: dataToSend,
        method: "post",
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data?.data.includes("not exist")) {
              toast.error(response.data?.data);
            } else {
              toast.success(response.data?.data);
              setFormData({
                email: "",
                userName: "",
              });
            }

            setLoader(false);
            // toast.success("You have successfully changed your Password!!");
            // navigate("/login");
          }
        })
        .catch((err) => {
          const { response = {} } = err || {};
          toast.error(response?.data?.message || "Something Went Wrong");
        });
    }
  };
  const formDataHandler = (e) => {
    const { name, value } = e.target || {};
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const returnToDash = () => {
    navigate("/");
  };

  return (
    <div
      className="login-container"
      style={{
        background: `url(${images.loginBackground}) no-repeat center center/cover`,
      }}
    >
      <div className="login-form-container">
        <img
          src={images.mainLogo}
          className="main-logo"
          alt="keventer's logo"
        />
        {/* <div className='font-size-medium text-center mt-[-1.6rem] font-[500] font-["Fraunces"]'>
          KICS - Keventers Internal Communication System
        </div> */}
        <div className="login-form flex flex-col justify-center">
          <div className="font-family-medium font-size-large mb-6">
            Enter Details To Change Password
          </div>
          {FORGET_PASSWORD_FIELDS.map((item, ind) => (
            <InputWithIcon
              key={ind}
              leftIcon={item.icons}
              placeholder={item.title}
              containerClassName="mb-4"
              wrapperClassName="w-[100%]"
              onChange={formDataHandler}
              autoComplete={"username"}
              value={formData[item.value]}
              name={item.value}
              fullEventData
            />
          ))}
          {/* <InputWithIcon
            leftIcon={icons.userIcon}
            placeholder="Enter your username"
            containerClassName="mb-4"
            wrapperClassName="w-[100%]"
            onChange={(text) => setUsername(text)}
            autoComplete={"username"}
            value={}
          />
          <InputWithIcon
            leftIcon={icons.passwordIcon}
            rightIcon={!hidePass ? icons.openEye : icons.closeEye}
            rightIconHandler={() => {
              setHidePass((prev) => !prev);
            }}
            rightIconStyle={{ top: "14px", right: "13px", cursor: "pointer" }}
            placeholder="Password"
            wrapperClassName="w-[100%]"
            onChange={(text) => setPassword(text)}
            autoComplete={hidePass ? "password" : "text"}
            type={hidePass ? "password" : "text"}
          /> */}
          <div className=" flex justify-end mt-1 w-[100%]">
            {/* <Checkbox
            title="Remember Me"
            checked={rememberMe}
            onChange={(isChecked) => setRememberMe(isChecked)}
          />             */}
            {/* <div className="font-size-small text-[var(--appColor)] cursor-pointer">
              Reset Password?
            </div> */}
            {/* <div
              className="flex justify-end cursor-pointer"
            >
              <span
                style={{ color: "#DB0106", fontSize: '14px' }}
                onClick={returnToDash}
              >
                Return to Dashboard
              </span>
            </div> */}
            <div
              className="font-size-small text-[var(--appColor)] cursor-pointer"
              onClick={returnToDash}
            >
              Back to Login
            </div>
          </div>
          <button
            className="login-button font-family-bold font-size-large !h-[5.8rem]"
            onClick={onSubmit}
            type="button"
          >
            Submit
          </button>
          <div className="font-size-small text-[var(--ultraLightGray)] mt-6 m-auto">
            &copy; Powered by CorePeelers
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
